export default __webpack_public_path__ + "static/media/Idea Forge Logo.b3615db1.png";